import { ArrowPathIcon } from '@heroicons/react/24/outline';
import * as Switch from '@radix-ui/react-switch';

/**
 * Toggle control for adding and removing products to a user's recurring items list.
 *
 * @param {boolean} [props.checked=false] - Whether the toggle is in the checked (recurring) state
 * @param {Function} [props.onCheckedChange] - Callback fired when the toggle state changes
 */
function RecurringToggle({ checked, onCheckedChange }) {
    return (
        <Switch.Root
            aria-label="Add to Recurring"
            className="group relative h-[42px] w-full min-w-60 max-w-[75px] rounded-[42px] bg-off-white"
            checked={checked}
            onCheckedChange={onCheckedChange}
            onClick={(e) => e.stopPropagation()}
        >
            <Switch.Thumb className="absolute left-5 top-1/2 flex aspect-square h-35 -translate-y-1/2 items-center justify-center rounded-full bg-grey-light transition-all duration-200 group-hover:bg-grey-dark data-[state=checked]:left-[calc(100%-40px)] data-[state=checked]:bg-mango group-hover:data-[state=checked]:bg-mango">
                <ArrowPathIcon className="w-[18px] stroke-[2px]" />
            </Switch.Thumb>
        </Switch.Root>
    );
}

export default RecurringToggle;
